import React, { useState } from "react";
import { _getBaseUrl } from "./helper";

const StateView = (props) => {
  const isDevSite =
    _getBaseUrl() === "http://circulair.ddev.site/" ||
    _getBaseUrl() === "https://circulair.ddev.site/";

  const [expanded, setExpanded] = useState(props.collapsed ? false : true);

  return (
    isDevSite && (
      <div className="cursor-pointer" onClick={() => setExpanded(!expanded)}>
        {expanded ? (
          <div
            className={`tema-stateview bg-black text-white rounded max-w-[90vw] ${
              props.floating ? "w-auto fixed z-[1]" : "w-full mb-4"
            }
           ${props.position ?? "bottom-4 right-4"} ${props.class ?? ""}`}
          >
            <div
              className={`text-desktopXS ${
                props.color ?? ""
              }  p-4 flex flex-col h-full`}
            >
              <h3 className="font-bold flex-shrink-0 pb-4">{props.title}</h3>
              <div className="flex-grow overflow-hidden">
                <div className="h-full overflow-y-auto">
                  <pre className="text-xs">
                    {JSON.stringify(props.values, "", 2)}
                  </pre>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            className={`w-auto h-[32px] bg-gray-800 bg-opacity-50 text-white px-4 rounded flex items-center justify-center ${
              props.floating ? "w-auto fixed z-[999]" : "w-full mb-4"
            }
            ${props.position ?? "bottom-4 right-4"} ${props.class ?? ""}`}
          >
            {props.title}
          </div>
        )}
      </div>
    )
  );
};

export default StateView;
